import * as Yup from "yup";

const subgrupoProdutosValidator = Yup.object().shape({
  ativado: Yup.boolean().nullable(),
  descricao: Yup.string().required("Descrição"),
});

export default subgrupoProdutosValidator;
